import React, { FC, MouseEventHandler } from 'react';

import CardContent from '../Card/CardContent';
import CardRow from '../Card/CardRow';
import Link, { IsActiveCheck } from '../Link';
import UnorderedList from '../UnorderedList';

import { sessionForms } from './SessionForm';

export interface AccountHelpersCardAppendixProps {
  currentPath: string;
  onClick?: React.MouseEventHandler;
  redirectUrl?: string;
}

export interface MenuItemCardRowProps {
  isActive: IsActiveCheck;
  onClick?: MouseEventHandler;
  path: string;
  name: string;
}

const MenuItemCardRow: FC<MenuItemCardRowProps> = ({ isActive, name, onClick, path }) => {
  return (
    <li>
      <Link isActive={isActive} to={path} onClick={onClick}>
        {name}
      </Link>
    </li>
  );
};

const AccountHelpersCardAppendix = ({
  currentPath,
  onClick,
  redirectUrl,
}: AccountHelpersCardAppendixProps): JSX.Element | null => {
  const isActive = (to: string) => to.split('?')[0] === currentPath;
  const params = redirectUrl ? `?redirect_url=${encodeURIComponent(redirectUrl)}` : '';

  return (
    <CardRow backdrop>
      <CardContent endSpacing>
        <UnorderedList>
          {sessionForms.map(({ name, path }) => (
            <MenuItemCardRow isActive={isActive} key={path} name={name} path={path + params} onClick={onClick} />
          ))}
        </UnorderedList>
      </CardContent>
    </CardRow>
  );
};

export default AccountHelpersCardAppendix;
